import { AnalyticsService } from './AnalyticsService';

export const analyticsService = new AnalyticsService();
